import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

export const ChangeBookingFooterContent: FC = () => {
  const booking = useSelector(manageFlowBookingSelector);
  if (!booking?.id) return null;

  return (
    <div className="flex items-center gap-2">
      <Icons.location />
      <Typography variant="body1-bold">
        <TransText i18nKey="changeTrips" />
      </Typography>
      <Typography variant="body1">({booking.id})</Typography>
    </div>
  );
};
